export const container = `relative h-[calc(100vh-48px)] w-full`;
